export default __webpack_public_path__ + "8a8a3fdb09b46b2527a432d420f6205a.jpg";